import { render, staticRenderFns } from "./VButtonSort.vue?vue&type=template&id=728d51a7&"
import script from "./VButtonSort.vue?vue&type=script&lang=ts&"
export * from "./VButtonSort.vue?vue&type=script&lang=ts&"
import style0 from "./VButtonSort.vue?vue&type=style&index=0&id=728d51a7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports